export default [
  {
    StateCode: 'AL',
    StateDescription: 'Alabama',
  },
  {
    StateCode: 'AK',
    StateDescription: 'Alaska',
  },
  {
    StateCode: 'AZ',
    StateDescription: 'Arizona',
  },
  {
    StateCode: 'AR',
    StateDescription: 'Arkansas',
  },
  {
    StateCode: 'CA',
    StateDescription: 'California',
  },
  {
    StateCode: 'CO',
    StateDescription: 'Colorado',
  },
  {
    StateCode: 'CT',
    StateDescription: 'Connecticut',
  },
  {
    StateCode: 'DE',
    StateDescription: 'Delaware',
  },
  {
    StateCode: 'DC',
    StateDescription: 'District Of Columbia',
  },
  {
    StateCode: 'FL',
    StateDescription: 'Florida',
  },
  {
    StateCode: 'GA',
    StateDescription: 'Georgia',
  },
  {
    StateCode: 'HI',
    StateDescription: 'Hawaii',
  },
  {
    StateCode: 'ID',
    StateDescription: 'Idaho',
  },
  {
    StateCode: 'IL',
    StateDescription: 'Illinois',
  },
  {
    StateCode: 'IN',
    StateDescription: 'Indiana',
  },
  {
    StateCode: 'IA',
    StateDescription: 'Iowa',
  },
  {
    StateCode: 'KS',
    StateDescription: 'Kansas',
  },
  {
    StateCode: 'KY',
    StateDescription: 'Kentucky',
  },
  {
    StateCode: 'LA',
    StateDescription: 'Louisiana',
  },
  {
    StateCode: 'ME',
    StateDescription: 'Maine',
  },
  {
    StateCode: 'MD',
    StateDescription: 'Maryland',
  },
  {
    StateCode: 'MA',
    StateDescription: 'Massachusetts',
  },
  {
    StateCode: 'MI',
    StateDescription: 'Michigan',
  },
  {
    StateCode: 'MN',
    StateDescription: 'Minnesota',
  },
  {
    StateCode: 'MS',
    StateDescription: 'Mississippi',
  },
  {
    StateCode: 'MO',
    StateDescription: 'Missouri',
  },
  {
    StateCode: 'MT',
    StateDescription: 'Montana',
  },
  {
    StateCode: 'NE',
    StateDescription: 'Nebraska',
  },
  {
    StateCode: 'NV',
    StateDescription: 'Nevada',
  },
  {
    StateCode: 'NH',
    StateDescription: 'New Hampshire',
  },
  {
    StateCode: 'NJ',
    StateDescription: 'New Jersey',
  },
  {
    StateCode: 'NM',
    StateDescription: 'New Mexico',
  },
  {
    StateCode: 'NY',
    StateDescription: 'New York',
  },
  {
    StateCode: 'NC',
    StateDescription: 'North Carolina',
  },
  {
    StateCode: 'ND',
    StateDescription: 'North Dakota',
  },
  {
    StateCode: 'OH',
    StateDescription: 'Ohio',
  },
  {
    StateCode: 'OK',
    StateDescription: 'Oklahoma',
  },
  {
    StateCode: 'OR',
    StateDescription: 'Oregon',
  },
  {
    StateCode: 'PA',
    StateDescription: 'Pennsylvania',
  },
  {
    StateCode: 'RI',
    StateDescription: 'Rhode Island',
  },
  {
    StateCode: 'SC',
    StateDescription: 'South Carolina',
  },
  {
    StateCode: 'SD',
    StateDescription: 'South Dakota',
  },
  {
    StateCode: 'TN',
    StateDescription: 'Tennessee',
  },
  {
    StateCode: 'TX',
    StateDescription: 'Texas',
  },
  {
    StateCode: 'UT',
    StateDescription: 'Utah',
  },
  {
    StateCode: 'VT',
    StateDescription: 'Vermont',
  },
  {
    StateCode: 'VA',
    StateDescription: 'Virginia',
  },
  {
    StateCode: 'WA',
    StateDescription: 'Washington',
  },
  {
    StateCode: 'WV',
    StateDescription: 'West Virginia',
  },
  {
    StateCode: 'WI',
    StateDescription: 'Wisconsin',
  },
  {
    StateCode: 'WY',
    StateDescription: 'Wyoming',
  },
];
